import {
  Button,
  Card,
  Col,
  Form,
  Input,
  PageHeader,
  Divider,
  message,
  notification,
  Row,
} from "antd";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import DovizSelectOption from "../components/toolbox/DovizSelectOption";
import strings from "../utils/Localization";
import { yuzdeHesala } from "../helpers/HesaplamaHelper";
import CurrencyInput, {
  setFieldsAutoClear,
} from "../components/toolbox/CurrencyInput";
import useApi from "../hooks/useApi";

function StokVaryantGrupDuzenle() {
  const [fetchLoading, setFetchLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const navigate= useNavigate();
  const { baslik, stokBilgileri, stokAlisFiyati, stokSatisFiyati, guncelle } =
    strings.stokVaryantGrupDuzenle;
  const { stokVaryantGrupId } = useParams();
  const api = useApi();

  useEffect(() => {
    fetchStok();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchStok = async () => {
    try {
      setLoading(true);
      const response = await api.post("/stokvaryantgrup/get", {
        Data: {
          id: stokVaryantGrupId,
        },
        SelectColumns: [
          {
            TableName: "",
            ColumnNames: ["id", "barkod", "gtin", "kod", "raf", "aciklama"],
          },
          {
            TableName: "StokvaryantgrupHasStokvaryantdeger.StokVaryantDeger",
            ColumnNames: ["id", "ad"],
          },
          {
            TableName:
              "StokvaryantgrupHasStokvaryantdeger.StokVaryantDeger.StokVaryant",
            ColumnNames: ["id", "ad"],
          },
          {
            TableName: "Stokvaryantgrupfiyat",
            ColumnNames: [
              "id",
              "fiyat",
              "otvTutar",
              "otvOran",
              "oivTutar",
              "oivOran",
              "kdvTutar",
              "kdvOran",
              "genelToplam",
              "satisMi",
            ],
          },
          {
            TableName: "Stokvaryantgrupfiyat.Doviz",
            ColumnNames: ["id", "ad", "kod", "simge"],
          },
        ],
      });
      if (response.status === 200) {
        const {
          barkod,
          gtin,
          kod,
          raf,
          aciklama,
          Stokvaryantgrupfiyat,
          // StokvaryantgrupHasStokvaryantdeger,
        } = response.data.data[0];

        const {
          fiyat: satisFiyat,
          kdvOran: satisKdvOran,
          otvOran: satisOtvOran,
          genelToplam: satisGenelToplam,
          Doviz: { id: satisDovizId },
        } = Stokvaryantgrupfiyat[0];
        const {
          fiyat: alisFiyat,
          kdvOran: alisKdvOran,
          otvOran: alisOtvOran,
          genelToplam: alisGenelToplam,
          Doviz: { id: alisDovizId },
        } = Stokvaryantgrupfiyat[1];

        form.setFields([
          {
            name: "barkodNo",
            value: barkod,
          },
          {
            name: "stokRafi",
            value: raf,
          },
          {
            name: "stokKodu",
            value: kod,
          },
          {
            name: "aciklama",
            value: aciklama,
          },
          {
            name: "gtinNumarasi",
            value: gtin,
          },
          {
            name: "vergilerHaricAlisFiyat",
            value: alisFiyat,
          },
          {
            name: "alisDovizId",
            value: String(alisDovizId),
          },
          {
            name: "alisKdvOran",
            value: alisKdvOran,
          },
          {
            name: "alisOtvOran",
            value: alisOtvOran,
          },
          {
            name: "vergilerDahilAlisFiyat",
            value: alisGenelToplam,
          },
          {
            name: "vergilerHaricSatisFiyat",
            value: satisFiyat,
          },
          {
            name: "satisDovizId",
            value: String(satisDovizId),
          },
          {
            name: "satisKdvOran",
            value: satisKdvOran,
          },
          {
            name: "satisOtvOran",
            value: satisOtvOran,
          },
          {
            name: "vergilerDahilSatisFiyat",
            value: satisGenelToplam,
          },
        ]);
      }
    } catch (error) {
      message.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const onFinish = async (values) => {
    try {
      const {
        barkodNo,
        stokRafi,
        stokKodu,
        gtinNumarasi,
        aciklama,
        vergilerHaricAlisFiyat,
        alisDovizId,
        alisKdvOran,
        alisOtvOran,
        vergilerDahilAlisFiyat,
        vergilerHaricSatisFiyat,
        satisDovizId,
        satisKdvOran,
        satisOtvOran,
        vergilerDahilSatisFiyat,
      } = values;

      //Satış KDV - OTV tutar
      const satisOtvTutar = yuzdeHesala(satisOtvOran, vergilerHaricSatisFiyat);
      const satisOtvliTutar =
        parseFloat(vergilerHaricSatisFiyat) + satisOtvTutar;
      const satisKdvTutar = yuzdeHesala(satisOtvliTutar, satisKdvOran);

      //Alış KDV - OTV tutar
      const alisOtvTutar = yuzdeHesala(alisOtvOran, vergilerHaricAlisFiyat);
      const alisOtvliTutar = parseFloat(vergilerHaricAlisFiyat) + alisOtvTutar;
      const alisKdvTutar = yuzdeHesala(alisOtvliTutar, alisKdvOran);
      setFetchLoading(true);

      const response = await api.put("/stokvaryantgrup/update", {
        Id: stokVaryantGrupId,
        Aciklama: aciklama,
        Barkod: barkodNo,
        Gtin: gtinNumarasi,
        Kod: stokKodu,
        Raf: stokRafi,
        ResimUrl: "",
        Stokvaryantgrupfiyat: [
          {
            DovizId: satisDovizId,
            Fiyat: vergilerHaricSatisFiyat,
            GenelToplam: vergilerDahilSatisFiyat,
            KdvOran: satisKdvOran,
            KdvTutar: satisKdvTutar,
            // OivOran: stokFiyat.satis.oivOran,
            // OivTutar: stokFiyat.satis.oivTutar,
            OtvOran: satisOtvOran,
            OtvTutar: satisOtvTutar,
            SatisMi: true,
          },
          {
            DovizId: alisDovizId,
            Fiyat: vergilerHaricAlisFiyat,
            GenelToplam: vergilerDahilAlisFiyat,
            KdvOran: alisKdvOran,
            KdvTutar: alisKdvTutar,
            // OivOran: stokFiyat.alis.oivOran,
            // OivTutar: stokFiyat.alis.oivTutar,
            OtvOran: alisOtvOran,
            OtvTutar: alisOtvTutar,
            SatisMi: false,
          },
        ],
      });

      if (response.status === 200) {
        notification["success"]({
          message: strings.mesaj.basarliBaslik,
          description: strings.mesaj.islemBasarili,
        });
      }
    } catch (error) {
      message.error(error.message);
    } finally {
      setFetchLoading(false);
    }
  };

  const alisFiyatHesaplama = (item) => {
    const {
      vergilerHaricAlisFiyat,
      alisKdvOran,
      alisOtvOran,
      vergilerDahilAlisFiyat,
    } = form.getFieldsValue([
      "vergilerHaricAlisFiyat",
      "alisKdvOran",
      "alisOtvOran",
      "vergilerDahilAlisFiyat",
    ]);
    const otvTutar = yuzdeHesala(alisOtvOran, vergilerHaricAlisFiyat);
    const otvliTutar = parseFloat(vergilerHaricAlisFiyat) + otvTutar;
    const kdvTutar = yuzdeHesala(otvliTutar, alisKdvOran);
    if (item === "vergilerHaricAlisFiyat") {
      const vergiDahilFiyat = parseFloat(otvliTutar + kdvTutar).toFixed(2);
      form.setFields([
        { name: "vergilerDahilAlisFiyat", value: vergiDahilFiyat },
      ]);
    } else if (item === "vergilerDahilAlisFiyat") {
      const vergiHaricFiyat = parseFloat(
        vergilerDahilAlisFiyat /
          (alisKdvOran / 100 + 1) /
          (alisOtvOran / 100 + 1)
      ).toFixed(2);
      form.setFields([
        { name: "vergilerHaricAlisFiyat", value: vergiHaricFiyat },
      ]);
    } else {
      const vergiDahilFiyat = parseFloat(otvliTutar + kdvTutar).toFixed(2);
      form.setFields([
        { name: "vergilerDahilAlisFiyat", value: vergiDahilFiyat },
      ]);
    }
  };
  const satisFiyatHesaplama = (item) => {
    const {
      vergilerHaricSatisFiyat,
      satisKdvOran,
      satisOtvOran,
      vergilerDahilSatisFiyat,
    } = form.getFieldsValue([
      "vergilerHaricSatisFiyat",
      "satisKdvOran",
      "satisOtvOran",
      "vergilerDahilSatisFiyat",
    ]);
    const otvTutar = yuzdeHesala(satisOtvOran, vergilerHaricSatisFiyat);
    const otvliTutar = parseFloat(vergilerHaricSatisFiyat) + otvTutar;
    const kdvTutar = yuzdeHesala(otvliTutar, satisKdvOran);
    if (item === "vergilerHaricSatisFiyat") {
      const vergiDahilFiyat = parseFloat(otvliTutar + kdvTutar).toFixed(2);
      form.setFields([
        { name: "vergilerDahilSatisFiyat", value: vergiDahilFiyat },
      ]);
    } else if (item === "vergilerDahilSatisFiyat") {
      const vergiHaricFiyat = parseFloat(
        vergilerDahilSatisFiyat /
          (satisKdvOran / 100 + 1) /
          (satisOtvOran / 100 + 1)
      ).toFixed(2);
      form.setFields([
        { name: "vergilerHaricSatisFiyat", value: vergiHaricFiyat },
      ]);
    } else {
      const vergiDahilFiyat = parseFloat(otvliTutar + kdvTutar).toFixed(2);
      form.setFields([
        { name: "vergilerDahilSatisFiyat", value: vergiDahilFiyat },
      ]);
    }
  };

  return (
    <>
      <PageHeader
        ghost={false}
        title={baslik}
        onBack={() => navigate(-1)}
        extra={
          <Button
            type="primary"
            size="large"
            htmlType="submit"
            style={{ float: "right" }}
            loading={fetchLoading}
            form="myForm"
          >
            {guncelle}
          </Button>
        }
      />
      <br />
      <Form
        form={form}
        onFinish={onFinish}
        size="middle"
        labelCol={{ span: 8 }}
        labelAlign="left"
        id="myForm"
      >
        <Row gutter={24}>
          <Col flex={1}>
            <Card loading={loading}>
              <Form.Item label={stokBilgileri.barkodNUmarasi} name="barkodNo">
                <Input />
              </Form.Item>
              <Form.Item label={stokBilgileri.stokRafi} name="stokRafi">
                <Input />
              </Form.Item>
              <Form.Item label={stokBilgileri.stokKodu} name="stokKodu">
                <Input />
              </Form.Item>
              <Form.Item label={stokBilgileri.gtinNumarasi} name="gtinNumarasi">
                <Input />
              </Form.Item>
              <Form.Item label={stokBilgileri.aciklama} name="aciklama">
                <Input.TextArea rows={1} />
              </Form.Item>
            </Card>
          </Col>
          <Col flex={1}>
            <Card loading={loading}>
              <Form.Item
                name="vergilerHaricAlisFiyat"
                label={stokAlisFiyati.vergilerHaricAlisFiyati}
                rules={[{ required: true }]}
              >
                <CurrencyInput
                  addonAfter={
                    <Form.Item
                      name="alisDovizId"
                      label={stokAlisFiyati.alisDovizTuru}
                      rules={[{ required: true }]}
                      noStyle
                    >
                      <DovizSelectOption showKod disabled />
                    </Form.Item>
                  }
                  onChange={() => alisFiyatHesaplama("vergilerHaricAlisFiyat")}
                  {...setFieldsAutoClear(form, "vergilerHaricAlisFiyat")}
                />
              </Form.Item>
              <Form.Item
                name="alisKdvOran"
                label={stokAlisFiyati.alisKdvOran}
                rules={[{ required: true }]}
              >
                <CurrencyInput
                  onChange={() => alisFiyatHesaplama("alisKdvOran")}
                  {...setFieldsAutoClear(form, "alisKdvOran")}
                />
              </Form.Item>
              <Form.Item
                name="alisOtvOran"
                label={stokAlisFiyati.alisOtvOran}
                rules={[{ required: true }]}
              >
                <CurrencyInput
                  onChange={() => alisFiyatHesaplama("alisOtvOran")}
                  {...setFieldsAutoClear(form, "alisOtvOran")}
                />
              </Form.Item>
              <Form.Item
                name="vergilerDahilAlisFiyat"
                label={stokAlisFiyati.vergilerDahilAlisFiyati}
                rules={[{ required: true }]}
              >
                <CurrencyInput
                  addonAfter={
                    <Form.Item
                      name="alisDovizId"
                      label={stokAlisFiyati.alisDovizTuru}
                      rules={[{ required: true }]}
                      noStyle
                    >
                      <DovizSelectOption showKod disabled />
                    </Form.Item>
                  }
                  onChange={() => alisFiyatHesaplama("vergilerDahilAlisFiyat")}
                  {...setFieldsAutoClear(form, "vergilerDahilAlisFiyat")}
                />
              </Form.Item>
              <Divider />
              <Form.Item
                name="vergilerHaricSatisFiyat"
                label={stokSatisFiyati.vergilerHaricSatisFiyati}
                rules={[{ required: true }]}
              >
                <CurrencyInput
                  addonAfter={
                    <Form.Item
                      name="satisDovizId"
                      label={stokAlisFiyati.satisDovizTuru}
                      rules={[{ required: true }]}
                      noStyle
                    >
                      <DovizSelectOption showKod disabled />
                    </Form.Item>
                  }
                  onChange={() =>
                    satisFiyatHesaplama("vergilerHaricSatisFiyat")
                  }
                  {...setFieldsAutoClear(form, "vergilerHaricSatisFiyat")}
                />
              </Form.Item>
              <Form.Item
                name="satisKdvOran"
                label={stokSatisFiyati.satisKdvOran}
                rules={[{ required: true }]}
              >
                <CurrencyInput
                  onChange={() => satisFiyatHesaplama("satisKdvOran")}
                  {...setFieldsAutoClear(form, "satisKdvOran")}
                />
              </Form.Item>
              <Form.Item
                name="satisOtvOran"
                label={stokSatisFiyati.satisOtvOran}
                rules={[{ required: true }]}
              >
                <CurrencyInput
                  onChange={() => satisFiyatHesaplama("satisOtvOran")}
                  {...setFieldsAutoClear(form, "satisOtvOran")}
                />
              </Form.Item>
              <Form.Item
                name="vergilerDahilSatisFiyat"
                label={stokSatisFiyati.vergilerDahilSatisFiyati}
                rules={[{ required: true }]}
              >
                <CurrencyInput
                  addonAfter={
                    <Form.Item
                      name="satisDovizId"
                      label={stokAlisFiyati.satisDovizTuru}
                      rules={[{ required: true }]}
                      noStyle
                    >
                      <DovizSelectOption showKod disabled />
                    </Form.Item>
                  }
                  onChange={() =>
                    satisFiyatHesaplama("vergilerDahilSatisFiyat")
                  }
                  {...setFieldsAutoClear(form, "vergilerDahilSatisFiyat")}
                />
              </Form.Item>
            </Card>
          </Col>
        </Row>
      </Form>
    </>
  );
}

export default StokVaryantGrupDuzenle;
